export const CANONICAL_ORIGIN = "https://spoergmig.dk";

export function canonicalUrl(path = "/") {
  const cleanPath = `/${String(path || "/").split("?")[0].split("#")[0]}`.replace(/\/+/g, "/");
  return `${CANONICAL_ORIGIN}${cleanPath === "/" ? "/" : cleanPath.replace(/\/$/, "")}`;
}

export function absoluteAssetUrl(url) {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  const backend = process.env.REACT_APP_BACKEND_URL || "";
  return `${url.startsWith("/api/") ? backend : CANONICAL_ORIGIN}${url.startsWith("/") ? url : `/${url}`}`;
}

export function isIndexablePublicPath(pathname) {
  return pathname === "/"
    || pathname === "/eksperter"
    || /^\/hjaelp\/[^/]+$/.test(pathname)
    || /^\/eksperter\/[^/]+$/.test(pathname)
    || pathname === "/kategorier"
    || pathname === "/blog"
    || pathname === "/om-spoergmig"
    || pathname === "/ekspertgodkendelse"
    || pathname === "/sikkerhed"
    || /^\/blog\/[^/]+$/.test(pathname);
}

export function productionHostname(hostname) {
  return [
    "spoergmig.dk",
    "www.spoergmig.dk",
    "spørgmig.dk",
    "xn--sprgmig-r1a.dk",
    "www.spørgmig.dk",
    "www.xn--sprgmig-r1a.dk",
  ].includes(String(hostname || "").toLowerCase());
}
